export const MarginTypeCell = ({ value }: { value: string }) => {
    return <span>{value === 'percent' ? 'Процент' : value }</span>
}
